export default __webpack_public_path__ + "static/media/people-at-counter.f0c5e447.jpg";